import React from 'react';

import { QBox, QDivider, QHeading, QStack, QEmptyState } from '@qualio/ui-components';
import { Document, File } from 'providers/types';
import { useTranslation } from 'react-i18next';
import { ViewFileCard } from 'v2components';
import { useRouterOutletSupplier } from 'v2views';

const SupplierDocuments: React.FC = () => {
  const { t } = useTranslation();
  const { supplier } = useRouterOutletSupplier();

  if (!supplier?.documents?.length)
    return (
      <QEmptyState
        title={t('supplierDocuments.emptyState.title')}
        subtitle={t('supplierDocuments.emptyState.subtitle')}
      />
    );

  const requiredDocuments = supplier?.documents
    ?.filter((document) => !(document?.title?.toLowerCase() === 'additional documents'))
    .map((item) => ({ ...item, name: item.title || item.name }));

  const additionalDocuments = supplier?.documents
    ?.filter((document) => document?.title?.toLowerCase() === 'additional documents')
    .map((item) => ({ ...item, name: item.title || item.name }));

  return (
    <QBox display="flex" flexDirection="column" maxWidth="800px">
      {requiredDocuments.map((document: Document, index) => (
        <QBox key={index}>
          <QStack direction="column" spacing={0} data-cy="supplier-document">
            <QHeading size="sm" pb={4}>
              {document?.name}
            </QHeading>
            {document.files?.map((file: File, index: number) => (
              <ViewFileCard key={index} file={file} />
            ))}
          </QStack>
          {index < requiredDocuments.length - 1 ? <QDivider my={6} /> : null}
        </QBox>
      ))}
      {additionalDocuments.length ? (
        <QStack direction="column" spacing={0} data-cy="supplier-document">
          <QHeading size="sm" pb={4}>
            {t('supplierDocuments.heading')}
          </QHeading>
          {additionalDocuments.map((document) =>
            document.files.map((file: File, index: number) => <ViewFileCard key={index} file={file} />),
          )}
        </QStack>
      ) : null}
    </QBox>
  );
};

export default SupplierDocuments;
